import { createElementBlock as o, openBlock as c, createTextVNode as e, createElementVNode as r, toDisplayString as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const a = {
  compatConfig: { MODE: 3 },
  name: "DtCodeblock",
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, d = { class: "d-codeblock" };
function p(l, i, t, _, m, f) {
  return c(), o("pre", null, [
    e("    "),
    r("code", d, n(t.text), 1),
    e(`
  `)
  ]);
}
const k = /* @__PURE__ */ s(a, [["render", p]]);
export {
  k as default
};
//# sourceMappingURL=codeblock.js.map
